/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Date_ToInputs */

const vi_common_date_to = /** @type {(inputs: Common_Date_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến ngày`)
};

/**

* @param {Common_Date_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_date_to = /** @type {((inputs?: Common_Date_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Date_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_date_to(inputs)
});